import React, {
  createContext,
  Dispatch,
  useContext,
  useEffect,
  useReducer,
} from "react";
import {
  BinInfo,
  ChartDataPoint,
  DropDownOptions,
  CategoryCount,
  NameValue,
  OverviewChart,
  WasteMngChartData,
  BinReportInfo,
  WasteCollectionChartData,
} from "../Models/Models";
import dayjs, { Dayjs } from "dayjs";
import { useLocation } from "react-router-dom";

export interface RecentActivities {
  avatarColorAct?: string;
  groupName: string;
  deviceName: string;
  message: string;
  dateTime: string;
}

export interface RecentInsights {
  avatarColorIns?: string;
  groupName: string;
  deviceName: string;
  message: string;
  dateTime: string;
}

export interface WasteManagementType {
  binPlottingmapCenter: { lat: number; lng: number } | null;
  binData: BinInfo[];
  DLCData: BinInfo[];
  selectedBin: BinInfo | null;
  selectedDLC: BinInfo | null;
  showBinFullnessChart: boolean;
  fullnessChartData: ChartDataPoint[];
  DLCChartData: ChartDataPoint[];
  map: google.maps.Map | null;
  isloading: boolean;

  groupOptions: DropDownOptions[];
  binTypeOptions: DropDownOptions[];

  selectedBintype: string;

  countOfBin: CategoryCount[];
  cleanCount: string;
  moderateCount: string;
  criticalCount: string;
  deviceLocations: { lat: number; lng: number }[];
  DLCAvgData: NameValue[];
  fillStsAvgData: NameValue[];
  fillStsType: OverviewChart;
  DLCStsType: OverviewChart;
  wasteCollectionAvgData: NameValue[];
  wasteCollectionType: OverviewChart;
  avgFillStschartView: "MOM" | "YOY";
  DLCchartView: "MOM" | "YOY";
  avgFillStsChartPage: number;
  DLCChartPage: number;
  avgWasteGenStschartView: string;
  avgWasteGenStschartPage: number;
  avgFillStsChartData: WasteMngChartData[];
  avgDLCChartData: WasteMngChartData[];
  avgWasteGenStsChartData: WasteCollectionChartData[];
  isBinFullnessChartLoad: boolean;
  isBinPlotingOnMapLoad: boolean;
  siteData: BinReportInfo[];
  open: boolean;
  typeLabel: string;
  rowData: BinReportInfo | null;
  totalBinMoniterValue: number;
  totalBinValueChanges: string;
  totalBinValueColor: string;
  averageFillBinlabel: number;
  avgBinValueChanges: string;
  avgBinValueColor: string;
  pageNo: number;
  pageSize: number;
  totalWasteMoniterValue: number;
  totalWasteValueChanges: string;
  totalWasteValueColor: string;
  averageFillWastelabel: number;
  avgWasteValueChanges: string;
  avgWasteValueColor: string;
  totalDLCMoniterValue: number;
  totalDLCValueColor: string;
  averageFillDLClabel: number;
  avgDLCValueChanges: string;
  avgDLCValueColor: string;
  totalDLCValueChanges: string;
  showDLCChart: boolean;
  isDLCChartLoad: boolean;
  isDLCPlotingOnMapLoad: boolean;
  totalElements: number;
  reportSelectedDate: Dayjs | null;
  isExportClicked: boolean;
  dicSelectedReportData: BinReportInfo | null;
  isDicSelectedImageOpen: boolean;
}

const initialState: WasteManagementType = {
  binPlottingmapCenter: null,
  binData: [],
  DLCData: [],
  selectedBin: null,
  selectedDLC: null,
  showBinFullnessChart: false,
  fullnessChartData: [],
  map: null,
  isloading: false,

  groupOptions: [],
  binTypeOptions: [],

  selectedBintype: "",

  countOfBin: [],
  cleanCount: "",
  moderateCount: "",
  criticalCount: "",
  deviceLocations: [],
  DLCAvgData: [],
  fillStsAvgData: [],
  fillStsType: {} as OverviewChart,
  wasteCollectionAvgData: [],
  wasteCollectionType: {} as OverviewChart,
  avgFillStschartView: "MOM",
  avgFillStsChartPage: 0,
  DLCChartPage: 0,
  avgWasteGenStschartView: "MOM",
  DLCchartView: "MOM",
  avgWasteGenStschartPage: 0,
  avgFillStsChartData: [],
  avgDLCChartData: [],
  avgWasteGenStsChartData: [],
  isBinFullnessChartLoad: false,
  isBinPlotingOnMapLoad: false,
  siteData: [] as BinReportInfo[],
  open: false,
  typeLabel: "",
  rowData: null,
  totalBinMoniterValue: 0,
  totalBinValueChanges: "",
  totalBinValueColor: "",
  averageFillBinlabel: 0,
  avgBinValueChanges: "",
  avgBinValueColor: "",
  pageNo: 0,
  pageSize: 10,
  totalWasteMoniterValue: 0,
  totalWasteValueChanges: "",
  totalWasteValueColor: "",
  averageFillWastelabel: 0,
  avgWasteValueChanges: "",
  avgWasteValueColor: "",

  totalDLCMoniterValue: 0,
  totalDLCValueColor: "",
  averageFillDLClabel: 0,
  avgDLCValueChanges: "",
  avgDLCValueColor: "",
  totalDLCValueChanges: "",
  showDLCChart: false,
  isDLCChartLoad: false,
  DLCChartData: [],
  isDLCPlotingOnMapLoad: false,
  DLCStsType: {} as OverviewChart,
  totalElements: 0,
  reportSelectedDate: null,
  isExportClicked: false,
  dicSelectedReportData: null,

  isDicSelectedImageOpen: false,
};

type ActionType =
  | {
      field: keyof WasteManagementType;
      type: "SET_FIELD";
      value:
        | string
        | string[]
        | boolean
        | BinInfo[]
        | BinInfo
        | DropDownOptions[]
        | ChartDataPoint[]
        | number
        | HTMLElement
        | dayjs.Dayjs
        | { lat: number; lng: number }
        | google.maps.Map
        | RecentActivities[]
        | RecentInsights[]
        | CategoryCount[]
        | { lat: number; lng: number }[]
        | null
        | OverviewChart
        | NameValue[]
        | WasteMngChartData[]
        | BinReportInfo[]
        | WasteCollectionChartData[];
    }
  | {
      type: "BULK_UPDATE";
      value: Partial<WasteManagementType>;
    }
  | {
      type: "RESET";
    }
  | {
      type: "SET_HAS_CHART_DATA"; // Add this line
      value: boolean; // Value type for hasChartData
    };

const WasteManagementProvider = createContext<{
  wasteManagementState: WasteManagementType;
  dispatchWasteManagement: Dispatch<ActionType>;
}>({
  wasteManagementState: initialState,
  dispatchWasteManagement: () => null,
});

type ContextProviderProps = {
  children: React.ReactNode;
};

const reducer = (
  state: WasteManagementType,
  action: ActionType
): WasteManagementType => {
  switch (action.type) {
    case "SET_FIELD":
      return { ...state, [action.field]: action.value };
    case "BULK_UPDATE":
      return { ...state, ...action.value };
    case "RESET":
      return { ...initialState };

    default:
      return state;
  }
};

const WasteManagementContext = ({ children }: ContextProviderProps) => {
  const [wasteManagementState, dispatchWasteManagement] = useReducer(
    reducer,
    initialState
  );

  return (
    <WasteManagementProvider.Provider
      value={{ wasteManagementState, dispatchWasteManagement }}
    >
      {children}
    </WasteManagementProvider.Provider>
  );
};

const useWasteManagement = () => {
  return useContext(WasteManagementProvider);
};

export { WasteManagementContext, useWasteManagement };
